import type {
  Communication,
  CommunicationAudience,
  CommunicationCategory,
  CommunicationStatus,
} from '@/api/types';

export type { Communication, CommunicationAudience, CommunicationCategory, CommunicationStatus };

/** The composer's fixed category/audience options (PLAN-FASE3.md WP-02) —
 * a code choice, not something the API enumerates, same spirit as
 * `php/api_communications.php`'s own constants. */
export const CATEGORIES: CommunicationCategory[] = [
  'algemeen',
  'veiligheid',
  'evenement',
  'vitaliteit',
  'hr',
];

export const AUDIENCES: CommunicationAudience[] = [
  'iedereen',
  'management',
  'per_afdeling',
  'per_locatie',
];
